import React, { useEffect, useState, Suspense, lazy } from "react"
import { Router, Location } from "@reach/router"
import GlobalStates from "../components/globalstates"
import Layout from "../components/layout"

import { TransitionGroup, CSSTransition } from "react-transition-group"

import "../assets/scss/typography.scss"
import "../assets/css/layout.css"

import Track from "../components/OrderTrack"
import { ThemeProvider } from "@mui/material"
import { defaultTheme } from "../themes"

import SplashScreen from "../components/SplashScreen"

import Preloader from "../components/SparklingPreloader"

import checkoutDetection from "../services/react-native/checkoutDetection"

import { withDeferRender, DeferRenderProvider } from 'react-defer-renderer'
let delay = 600



const IndexPage = withDeferRender(lazy(() => import('../components/MasterIndexPage')), { fallback: <Preloader /> })

const Homemade = withDeferRender(lazy(() => import('../components/Homemade/MainIndexPage')), { fallback: <Preloader /> })

const SearchPage = withDeferRender(lazy(() => import("../components/Homemade/SearchPage/SearchPage")), { fallback: <Preloader /> })

const NotificationPage = withDeferRender(lazy(() => import("../components/Homemade/NotificationPage/NotificationPage")), { fallback: <Preloader /> })

const Account = withDeferRender(lazy(() => import("../components/Homemade/AccountPage/AccountPage")), { fallback: <Preloader /> })

const Shop = withDeferRender(lazy(() => import("../components/Homemade/ShopPage/ShopPage")), { fallback: <Preloader /> })

const Product = withDeferRender(lazy(() => import("../components/Homemade/ProductPage/ProductPage")), { fallback: <Preloader /> })

const Registration = withDeferRender(lazy(() => import("../components/RegistrationPage")), { fallback: <Preloader /> })

const ResetPassword = withDeferRender(lazy(() => import("../components/ResetPasswordPage")), { fallback: <Preloader /> })

const UserDetails = withDeferRender(lazy(() => import("../components/Homemade/AccountPage/UserDetailsPage")), { fallback: <Preloader /> })

const UserUpdate = withDeferRender(lazy(() => import("../components/Homemade/AccountPage/UpdateAccountPage")), { fallback: <Preloader /> })

const PurchaseHistory = withDeferRender(lazy(() => import("../components/Homemade/AccountPage/PurchaseHistoryPage")), { fallback: <Preloader /> })

const PurchaseHistoryItem = withDeferRender(lazy(() => import("../components/Homemade/AccountPage/PurchaseHistoryItem")), { fallback: <Preloader /> })

const MapPage = withDeferRender(lazy(() => import("../components/MapPicker/MapPage")), { fallback: <Preloader /> })

const AddressSearchPage = withDeferRender(lazy(() => import("../components/MapPicker/AddressSearchPage")), { fallback: <Preloader /> })

const BagPage = withDeferRender(lazy(() => import("../components/Homemade/BagPage/BagPage")), { fallback: <Preloader /> })

const CheckoutPage = withDeferRender(lazy(() => import("../components/Homemade/CheckoutPage/CheckoutPage")), { fallback: <Preloader /> })

const OngoingOrderDetails = withDeferRender(lazy(() => import("../components/Homemade/OngoingOrderPage/OngoingOrderDetails")), { fallback: <Preloader /> })

const RatingsPage = withDeferRender(lazy(() => import("../components/Homemade/RatingsPage/RatingsPage")), { fallback: <Preloader /> })

const SubmitRatingsPage = withDeferRender(lazy(() => import("../components/Homemade/RatingsPage/SubmitRatingsPage")), { fallback: <Preloader /> })

const HelpCenter = withDeferRender(lazy(() => import("../components/HelpCenter/HelpCenter")), { fallback: <Preloader /> })

const TawkToPage = withDeferRender(lazy(() => import("../components/HelpCenter/components/TawkToPage")), { fallback: <Preloader /> })

const AirSparkleGame = withDeferRender(lazy(() => import("../components/air")), { fallback: <Preloader /> })

const SparkExpress = withDeferRender(lazy(() => import("../components/sparkexpress")), { fallback: <Preloader /> })

const VortexTopUpPage = withDeferRender(lazy(() => import("../components/Vortex/pages/VortexTopUpPage")), { fallback: <Preloader /> })

const VortexBillsPaymentPage = withDeferRender(lazy(() => import("../components/Vortex/pages/VortexBillsPaymentPage")), { fallback: <Preloader /> })

const VortexVoucherPage = withDeferRender(lazy(() => import("../components/Vortex/pages/VortexVoucherPage")), { fallback: <Preloader /> })

const VortexTransactionHistory = withDeferRender(lazy(() => import("../components/Vortex/pages/VortexTransactionHistory")), { fallback: <Preloader /> })

const VortexTransactionHistoryDetails = withDeferRender(lazy(() => import("../components/Vortex/pages/VortexTransactionHistoryDetails")), { fallback: <Preloader /> })

const PaymongoRefundDetailsPage = withDeferRender(lazy(() => import("../services/paymongo/components/pages/PaymongoRefundDetailsPage")), { fallback: <Preloader /> })

const Application = () => {
  console.log("render app here")

  useEffect(() => {
    checkoutDetection()
  }, [])

  if (typeof window !== "undefined" && window.ReactNativeWebView) {
    //
    let location = window.location.pathname

    if (location === "/express")
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "SPARK_EXPRESS",
        })
      )
    else
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "SPARKLE",
        })
      )
  }

  return (
    <>
      {/*<PushNotifications file={notificationServiceWorker} />*/}
      <ThemeProvider theme={defaultTheme}>
        <GlobalStates>
          <Layout>
            <DeferRenderProvider>
              <Suspense fallback = {<Preloader/>}>
              <Location>
                {({ location }) => (
                  <Router>
                    <IndexPage path="/" />
                    <Homemade path="/food" />
                    <SearchPage path="/search" />
                    <NotificationPage path="/alerts" />
                    <Account path="/account" />
                    <Shop path="/shop" />
                    <Shop path="/shop/:shopId" />
                    <Product path="/product" />
                    <Registration path="/registration" />
                    <ResetPassword path="/reset" />
                    <UserDetails path="/user" />
                    <UserUpdate path="/user/update" />
                    <PurchaseHistory path="/user/history" />
                    <PurchaseHistoryItem path="user/history/:id" />
                    <MapPage path="/MapPage" />
                    <AddressSearchPage path="/AddressSearchPage" />
                    <BagPage path="/bagpage" />
                    <CheckoutPage path="/checkoutpage" />
                    <OngoingOrderDetails path="/ongoingOrderDetails" />
                    <RatingsPage path="/ratingspage" />
                    <SubmitRatingsPage path="/submitratingspage" />
                    <HelpCenter path="/helpcenter" />
                    <TawkToPage path="/chatsupportpage" />
                    <AirSparkleGame path="/air" />
                    <SparkExpress path="/express" />
                    <Track path="ongoingOrderDetails/track/:orderId" />
                    <VortexTopUpPage path="/vortextopup" />
                    <VortexBillsPaymentPage path="/vortexbillspayment" />
                    <VortexVoucherPage path="/vortexvoucher" />
                    <VortexTransactionHistory path="/vortextransactions" />
                    <VortexTransactionHistoryDetails path="/vortextransactions/:type/:refId" />
                    <PaymongoRefundDetailsPage path="/paymongo/refund/details/:refId" />
                  </Router>
                )}
              </Location>
              </Suspense>
            </DeferRenderProvider>
          </Layout>
        </GlobalStates>
      </ThemeProvider>
    </>
  )
}

const App = ({ data }) => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let mounted = true

    if (mounted)
      setTimeout(() => {
        setLoaded(true)
      }, 2000)

    return () => {
      mounted = false
    }
  }, [])

  return <>{loaded ? <Application /> : <SplashScreen />}</>
}

export default App
